import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Row, Col } from "reactstrap"
import ClosedBiddingTable from "./ClosedBiddingTable"
import { setBreadcrumbItems } from "store/actions"

interface ClosedBiddingPageProps {
  setBreadcrumbItems: (title: string, items: { title: string; link: string }[]) => void
}

const BREADCRUMB = [
  { title: "SOLDX", link: "#" },
  { title: "Closed Bidding", link: "#" },
]

const ClosedBiddingPage = (props: ClosedBiddingPageProps) => {
  useEffect(() => {
    document.title = "Closed Bidding | SOLDX"
    props.setBreadcrumbItems("Closed Bidding", BREADCRUMB)
  }, [props])

  return (
    <>
      <Row>
        <Col xl="12">
          <ClosedBiddingTable />
        </Col>
      </Row>
    </>
  )
}

export default connect(null, { setBreadcrumbItems })(ClosedBiddingPage)
